import { format as formatDate } from "date-fns";
import { dateFnsOptions } from "../_utils/dateFnsLocale";
import {
  HYDRATE,
  ADD_PARTNER,
  SET_CALENDAR_DATE,
  GET_PARTNERS,
  DELETE_PARTNER,
  SET_DESIGN,
  REMOVE_DESIGN,
  SET_CHANNEL_SLOTS,
  UPDATE_CHANNEL_SLOTS,
  DELETE_CHANNEL_SLOT,
  REFRESH_POST_VIEW,
  SET_PLANNER_VIEW,
  SET_POSTS_VIEW,
  SET_POSTS,
  SET_POSTS_LIST,
  START_MOVE_POSTS,
  END_MOVE_POSTS,
  START_SWAP_POSTS,
  END_SWAP_POSTS,
  SET_FULL_SCREEN,
  OPEN_POST_EDITOR,
  CLOSE_POST_EDITOR,
  SET_MEDIA_SIDEBAR_PANEL_OPEN,
  SET_PLANNER_TIMEZONE,
  SET_DRAFTS_VIEW,
  REFRESH_DRAFTS_VIEW,
  SET_DRAFTS_DATA,
  SET_DRAFTS_LIST,
  SET_POSTS_BULK_IMPORT_OPEN,
  SET_POSTS_BULK_IMPORT_ITEMS,
  UPDATE_POSTS_BULK_IMPORT_ITEM,
  REMOVE_POSTS_BULK_IMPORT_ITEM,
  SET_EVENTS_BY_DAY,
  SET_EVENTS_CATEGORIES,
  SET_SELECTED_EVENTS_CATEGORIES,
  SET_WORKFLOW_TYPE,
} from "../_actions/types";
import * as PublishingViewTypes from "../_constants/PublishingViews";
import * as PlannerViewTypes from "../_constants/PlannerViews";
import * as DraftViewTypes from "../_constants/DraftViews";

const postsInit = (initialItems) => {
  const posts = {
    ...initialItems,
  };

  const postsMap = {};

  Object.keys(posts).forEach((key) => {
    posts[key].forEach((item) => {
      postsMap[item.id] = key;
    });
  });

  return {
    posts,
    postsMap,
  };
};

export const initialState = {
  calendarDate: new Date(),
  partners: [],
  designToPublish: [],
  designType: null,
  channelSlots: {},
  fullScreenEnabled: false,
  postsView: {},
  ...postsInit({}),
  requirePostsViewUpdate: 0,
  postEditorData: null,
  mediaSidebarPanelOpen: false,
  plannerView: {
    type: PlannerViewTypes.DRAFTS,
  },
  publishingView: {
    type: PublishingViewTypes.CALENDAR,
  },
  postsList: {
    posts: [],
  },
  timezone: null,
  // events
  eventsByDay: {},
  eventsCategories: {
    categories: [],
    selected: ["1"],
  },
  // bulk import
  postsBulkImportOpen: false,
  postsBulkImportItems: [],
  // drafts
  draftsView: {
    type: DraftViewTypes.GRID,
  },
  requireDraftsViewUpdate: 0,
  drafts: {
    items: [],
    params: {
      page: 1,
      accountsIds: [],
      search: "",
    },
    hasMore: false,
  },
};

const plannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE: // @NOTE merge part of persisted state with initialState
      return { ...initialState, ...state };
    case GET_PARTNERS:
      return {
        ...state,
        partners: action.payload,
      };
    case ADD_PARTNER:
      let newPartners = state.partners.concat(action.payload);
      return {
        ...state,
        partners: newPartners,
      };
    case DELETE_PARTNER:
      let remainingPartners = state.partners.filter(
        (partner) => partner.id !== action.payload
      );
      return {
        ...state,
        partners: remainingPartners,
      };
    case SET_DESIGN:
      let designsArray = action.payload.designData
        ? state.designToPublish.concat(action.payload.designData)
        : initialState.designToPublish;
      return {
        ...state,
        designToPublish: designsArray,
        designType: action.payload.type,
      };
    case REMOVE_DESIGN:
      let remainingDesigns = action.payload
        ? state.designToPublish.filter((design) => design.id !== action.payload)
        : initialState.designToPublish;
      return {
        ...state,
        designToPublish: remainingDesigns,
        designType: null,
      };
    case SET_CHANNEL_SLOTS:
      return {
        ...state,
        channelSlots: action.payload,
      };
    case UPDATE_CHANNEL_SLOTS:
      let updatedSlots = state.channelSlots.concat(action.payload);
      return {
        ...state,
        channelSlots: updatedSlots,
      };
    case DELETE_CHANNEL_SLOT:
      let remainingSlots = state.channelSlots.filter(
        (e) => e.id !== action.payload
      );
      return {
        ...state,
        channelSlots: remainingSlots,
      };
    case SET_POSTS_VIEW:
      return {
        ...state,
        postsView: action.payload,
      };
    case SET_PLANNER_VIEW:
      return {
        ...state,
        publishingView: {
          ...state.publishingView,
          ...action.payload,
        },
      };
    case SET_CALENDAR_DATE:
      return {
        ...state,
        calendarDate: action.payload,
      };
    case SET_PLANNER_TIMEZONE:
      return {
        ...state,
        timezone: action.payload,
      };
    case SET_FULL_SCREEN:
      return {
        ...state,
        fullScreenEnabled: action.payload,
      };
    case SET_EVENTS_CATEGORIES: {
      return {
        ...state,
        eventsCategories: {
          ...state.eventsCategories,
          categories: action.payload || [],
        },
      };
    }
    case SET_SELECTED_EVENTS_CATEGORIES: {
      return {
        ...state,
        eventsCategories: {
          ...state.eventsCategories,
          selected: action.payload || [],
        },
      };
    }
    case SET_EVENTS_BY_DAY: {
      return {
        ...state,
        eventsByDay: action.payload || {},
      };
    }
    case SET_POSTS_BULK_IMPORT_OPEN:
      return {
        ...state,
        postsBulkImportOpen: action.payload,
      };
    case SET_POSTS_BULK_IMPORT_ITEMS: {
      return {
        ...state,
        postsBulkImportItems: action.payload,
      };
    }
    case UPDATE_POSTS_BULK_IMPORT_ITEM: {
      const items = state.postsBulkImportItems.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }

        return item;
      });
      return {
        ...state,
        postsBulkImportItems: items,
      };
    }
    case REMOVE_POSTS_BULK_IMPORT_ITEM: {
      const items = state.postsBulkImportItems.filter(
        (item) => item.id !== action.payload
      );

      return {
        ...state,
        postsBulkImportItems: items,
      };
    }
    case START_MOVE_POSTS: {
      const { id, date } = action.payload;
      const key = state.postsMap[id];

      if (!id || !date || !key) {
        return state;
      }

      const itemState = state.posts[key].find((item) => item.id === id);

      if (!itemState) {
        return state;
      }

      const newKey = formatDate(date, "yyyy-MM-dd", dateFnsOptions());

      const newState = {
        ...state,
        posts: {
          ...state.posts,
          [key]: state.posts[key].filter((item) => item.id !== id),
        },
        postsMap: {
          ...state.postsMap,
          [id]: newKey,
        },
      };

      if (!newState.posts[newKey]) {
        newState.posts[newKey] = [];
      }

      newState.posts[newKey].push({
        ...itemState,
        date,
        loading: true,
        _date: itemState.date, // @NOTE backup
        _key: key, // @NOTE backup
      });

      return newState;
    }
    case END_MOVE_POSTS: {
      const { id, error } = action.payload;
      const key = state.postsMap[id];

      if (!id || !key) {
        return state;
      }

      const itemState = state.posts[key].find((item) => item.id === id);

      if (!itemState) {
        return state;
      }

      if (!error) {
        const newState = {
          ...state,
          posts: {
            ...state.posts,
            [key]: state.posts[key].map((item) => {
              if (item.id === id) {
                const newItem = {
                  ...item,
                  data: {
                    ...item.data,
                    post: {
                      ...item.data.post,
                      date: formatDate(
                        item.date,
                        "yyyy-MM-dd",
                        dateFnsOptions()
                      ),
                      time: formatDate(item.date, "HH:mm", dateFnsOptions()),
                    },
                  },
                };

                delete newItem._key; // eslint-disable-line no-underscore-dangle
                delete newItem._date; // eslint-disable-line no-underscore-dangle
                delete newItem.loading;

                return newItem;
              }

              return item;
            }),
          },
        };

        return newState;
      }

      // @NOTE restore date/time

      const newKey = itemState._key; // eslint-disable-line no-underscore-dangle
      const newDate = itemState._date; // eslint-disable-line no-underscore-dangle

      if (!newKey || !newDate) {
        return state;
      }

      const newState = {
        ...state,
        posts: {
          ...state.posts,
          [key]: state.posts[key].filter((item) => item.id !== id),
        },
        postsMap: {
          ...state.postsMap,
          [id]: newKey,
        },
      };

      if (!newState.posts[newKey]) {
        newState.posts[newKey] = [];
      }

      const newItem = {
        ...itemState,
        date: newDate,
      };

      delete newItem._key; // eslint-disable-line no-underscore-dangle
      delete newItem._date; // eslint-disable-line no-underscore-dangle
      delete newItem.loading;

      newState.posts[newKey].push(newItem);

      return newState;
    }
    case START_SWAP_POSTS: {
      const { id, secondId } = action.payload;
      const key = state.postsMap[id];
      const secondKey = state.postsMap[secondId];

      if (!id || !secondId || !key || !secondKey) {
        return state;
      }

      const itemState = state.posts[key].find((item) => item.id === id);
      const secondItemState = state.posts[secondKey].find(
        (item) => item.id === secondId
      );

      if (!itemState || !secondItemState) {
        return state;
      }

      const newState = {
        ...state,
        posts: {
          ...state.posts,
          [key]: state.posts[key].filter(
            (item) => item.id !== id && item.id !== secondId
          ),
          [secondKey]: state.posts[secondKey].filter(
            (item) => item.id !== id && item.id !== secondId
          ),
        },
        postsMap: {
          ...state.postsMap,
          [id]: secondKey,
          [secondId]: key,
        },
      };

      newState.posts[secondKey].push({
        ...itemState,
        date: secondItemState.date,
        loading: true,
        _date: itemState.date, // @NOTE backup
        _key: key, // @NOTE backup
      });

      newState.posts[key].push({
        ...secondItemState,
        date: itemState.date,
        loading: true,
        _date: secondItemState.date, // @NOTE backup
        _key: secondKey, // @NOTE backup
      });

      return newState;
    }
    case END_SWAP_POSTS: {
      const { id, secondId, error } = action.payload;
      const key = state.postsMap[id];
      const secondKey = state.postsMap[secondId];

      if (!id || !secondId || !key || !secondKey) {
        return state;
      }

      const itemState = state.posts[key].find((item) => item.id === id);
      const secondItemState = state.posts[secondKey].find(
        (item) => item.id === secondId
      );

      if (!itemState || !secondItemState) {
        return state;
      }

      if (!error) {
        const mapItem = (item) => {
          if (item.id === id || item.id === secondId) {
            const newItem = {
              ...item,
              data: {
                ...item.data,
                post: {
                  ...item.data.post,
                  date: formatDate(item.date, "yyyy-MM-dd", dateFnsOptions()),
                  time: formatDate(item.date, "HH:mm", dateFnsOptions()),
                },
              },
            };

            delete newItem._key; // eslint-disable-line no-underscore-dangle
            delete newItem._date; // eslint-disable-line no-underscore-dangle
            delete newItem.loading;

            return newItem;
          }

          return item;
        };

        const newState = {
          ...state,
          posts: {
            ...state.posts,
            [key]: state.posts[key].map(mapItem),
            [secondKey]: state.posts[secondKey].map(mapItem),
          },
        };

        return newState;
      }

      // @NOTE restore date/time

      const newKey = itemState._key; // eslint-disable-line no-underscore-dangle
      const newDate = itemState._date; // eslint-disable-line no-underscore-dangle
      const secondNewKey = secondItemState._key; // eslint-disable-line no-underscore-dangle
      const secondNewDate = secondItemState._date; // eslint-disable-line no-underscore-dangle

      if (!newKey || !newDate || !secondNewKey || !secondNewDate) {
        return state;
      }

      const newState = {
        ...state,
        posts: {
          ...state.posts,
          [key]: state.posts[key].filter(
            (item) => item.id !== id && item.id !== secondId
          ),
          [secondKey]: state.posts[secondKey].filter(
            (item) => item.id !== id && item.id !== secondId
          ),
        },
        postsMap: {
          ...state.postsMap,
          [id]: newKey,
          [secondId]: secondNewKey,
        },
      };

      if (!newState.posts[newKey]) {
        newState.posts[newKey] = [];
      }

      const newItem = {
        ...itemState,
        date: newDate,
      };

      delete newItem._key; // eslint-disable-line no-underscore-dangle
      delete newItem._date; // eslint-disable-line no-underscore-dangle
      delete newItem.loading;

      newState.posts[newKey].push(newItem);

      if (!newState.posts[secondNewKey]) {
        newState.posts[secondNewKey] = [];
      }

      const secondNewItem = {
        ...secondItemState,
        date: secondNewDate,
      };

      delete secondNewItem._key; // eslint-disable-line no-underscore-dangle
      delete secondNewItem._date; // eslint-disable-line no-underscore-dangle
      delete secondNewItem.loading;

      newState.posts[secondNewKey].push(secondNewItem);

      return newState;
    }
    case SET_POSTS: {
      return {
        ...state,
        ...postsInit(action.payload),
      };
    }
    case SET_POSTS_LIST: {
      if (action.payload.infiniteScroll) {
        return {
          ...state,
          postsList: {
            ...action.payload,
            posts: [...state.postsList.posts, ...action.payload.posts],
          },
        };
      }

      return {
        ...state,
        postsList: {
          ...action.payload,
        },
      };
    }
    case REFRESH_POST_VIEW: {
      return {
        ...state,
        requirePostsViewUpdate: state.requirePostsViewUpdate + 1,
      };
    }
    case OPEN_POST_EDITOR: {
      return {
        ...state,
        postEditorData: action.payload,
      };
    }
    case CLOSE_POST_EDITOR: {
      return {
        ...state,
        postEditorData: null,
      };
    }
    case SET_MEDIA_SIDEBAR_PANEL_OPEN:
      return {
        ...state,
        mediaSidebarPanelOpen: action.payload,
      };
    case SET_WORKFLOW_TYPE:
      return {
        ...state,
        workflowType: action.payload,
      };
    case SET_DRAFTS_VIEW:
      return {
        ...state,
        draftsView: {
          ...state.draftsView,
          ...action.payload,
        },
      };
    case REFRESH_DRAFTS_VIEW: {
      return {
        ...state,
        requireDraftsViewUpdate: state.requireDraftsViewUpdate + 1,
      };
    }
    case SET_DRAFTS_LIST: {
      return {
        ...state,
        drafts: {
          ...state.drafts,
          items: action.payload
        }
      };
    }
    case SET_DRAFTS_DATA:
      return {
        ...state,
        drafts: {
          ...state.drafts,
          items: action.payload.append
            ? state.drafts.items.concat(action.payload.items)
            : action.payload.items,
          params: {
            ...state.drafts.params,
            ...action.payload.params,
          },
          hasMore: action.payload.hasMore,
          pages_count: action.payload.pages_count,
          current_page: action.payload.current_page,
        },
      };
    default:
      return state;
  }
};

export default plannerReducer;
